import { Stack, Typography } from "@mui/material";
import { useResource, Resources } from "Infrastructure/Translations/Resources";
import { BlButton } from "Shared/Buttons/BlButton";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";
import { UnstyledLink } from "Shared/Routing/UnstyledLink";
import HomeIcon from "@mui/icons-material/Home";
import { useSignOut } from "Auth/Hooks/useSignOut";
import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import { Navigate } from "react-router-dom";
import { AppRouting, getPath } from "Infrastructure/Utils/UrlUtils";

export const Error403Page: React.FunctionComponent = (_) => {
  const { t } = useResource();
  const { data, isLoading } = useUserInfoQuery();
  const signOut = useSignOut();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (data?.status !== 200) {
    return <Navigate to={getPath(AppRouting.SignIn)} replace />;
  }

  return (
    <AuthenticatedLayout title={"403"}>
      <Stack alignItems="center" spacing={2} mt={8}>
        <Typography variant="h1">Error 403</Typography>
        <Typography variant="h2">
          {t(Resources.Errors.Error403.Subtitle)}
        </Typography>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          mt={2}
        >
          <UnstyledLink to="/">
            <BlButton
              startIcon={<HomeIcon />}
              size="large"
              variant="contained"
              color="primary"
            >
              {t(Resources.Errors.Error404.Home)}
            </BlButton>
          </UnstyledLink>

          <BlButton onClick={() => signOut()}>
            {t(Resources.Common.SignOut)}
          </BlButton>
        </Stack>
      </Stack>
    </AuthenticatedLayout>
  );
};
